module.exports = __webpack_public_path__ + "img/yellow-gem-horizontal.82793341.svg";